export default {
    root: function (_a) {
        var props = _a.props;
        return ({
            class: {
                'tw-opacity-60 tw-select-none tw-pointer-events-none tw-cursor-default': props.disabled,
            },
        });
    },
    pcToggleButton: {
        root: {
            class: [
                // layout & spacing
                'tw-grow xs:tw-grow-0 ',
                'tw-justify-center tw-inline-flex tw-items-center tw-text-center tw-relative tw-overflow-hidden tw-select-none tw-cursor-pointer',
                'tw-px-3 tw-py-1.5 tw-transition tw-duration-200 tw-border tw-border-r-0',
                // first/last rounding
                'first:tw-rounded-l-md first:tw-rounded-tr-none first:tw-rounded-br-none',
                'last:tw-border-r last:tw-rounded-tl-none last:tw-rounded-bl-none last:tw-rounded-r-md',
                // focus styles
                'focus:tw-outline-none focus:tw-ring-0 focus:tw-ring-offset-0',
                'focus-visible:tw-z-10 focus-visible:tw-outline-2 focus-visible:tw-ring-2 focus-visible:tw-ring-offset-2 focus-visible:tw-ring-primary-700',
                // inactive
                'tw-text-gray-900 dark:tw-text-gray-100',
                'tw-bg-white tw-border-gray-300',
                'hover:tw-bg-gray-200 hover:tw-border-gray-200',
                'dark:tw-bg-zinc-700 dark:tw-border-zinc-500 dark:hover:tw-bg-zinc-600',
                // active
                'data-[p-checked=true]:tw-text-white',
                'data-[p-checked=true]:tw-bg-primary-500',
                'data-[p-checked=true]:tw-border-primary-500',
            ],
        },
        label: {
            class: 'tw-text-base',
        },
    },
};
